import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Image } from '@fluentui/react';
import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';

export const PlacementImage = ({
  i18n,
  image,
  enableCrop,
  previewImageAspectRatio,
  previewImageHeight,
  placementImageClassName,
}) => {
  if (image && image.src) {
    if (enableCrop) {
      return (
        <div className={classnames(placementImageClassName, 'ad-preview-image-content')}>
          <CroppedImageView
            SourceWidth={image.cropSettings ? image.cropSettings.SourceWidth : 0}
            SourceX={image.cropSettings ? image.cropSettings.SourceX : 0}
            SourceY={image.cropSettings ? image.cropSettings.SourceY : 0}
            aspectRatio={previewImageAspectRatio}
            originalHeight={image.height}
            originalWidth={image.width}
            resizeImageHeight={previewImageHeight}
            src={image.src}
          />
        </div>
      );
    }
    return (<Image
      className={classnames(placementImageClassName, 'ad-preview-image-content')}
      src={image.src}
      height={previewImageHeight}
      alt={i18n.getString(_TL_('Ad preview image'))}
      shouldFadeIn
    />);
  }
  return null;
};

PlacementImage.propTypes = {
  classes: PropTypes.shape({
    placementImage: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  image: PropTypes.shape({
    src: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    cropSettings: PropTypes.shape({
      SourceWidth: PropTypes.number,
      SourceX: PropTypes.number,
      SourceY: PropTypes.number,
    }),
  }),
  enableCrop: PropTypes.bool,
  previewImageAspectRatio: PropTypes.number,
  previewImageHeight: PropTypes.number,
  placementImageClassName: PropTypes.string,
};

PlacementImage.defaultProps = {
  image: {},
  enableCrop: false,
  previewImageAspectRatio: 1.78,
  previewImageHeight: 100,
  placementImageClassName: '',
};
